import { FC } from 'react';

import Stage, { StageGuestProps } from './Guest.Stage';
import Viewer, { ViewerGuestProps } from './Guest.Viewer';

export type GuestComposition = {
  Stage: FC<StageGuestProps>;
  Viewer: FC<ViewerGuestProps>;
};

const Guest: FC<{}> & GuestComposition = ({ children, ...props }): JSX.Element => <>{children}</>;

Guest.Stage = Stage;
Guest.Viewer = Viewer;

export default Guest;
